import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Компонент для автоматической прокрутки страницы вверх при переходе на новую страницу
 * Использует хук useLocation для отслеживания изменений в URL
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // При изменении пути прокручиваем страницу вверх
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Компонент не рендерит никакой UI
};

export default ScrollToTop;
